import { observer } from 'mobx-react-lite';
import { CommandButton } from 'office-ui-fabric-react/lib/Button';
import getEmoji from 'owa-expressions-store/lib/utils/getEmoji';
import getEmojiCodePointWithSkinTone from 'owa-expressions-store/lib/utils/getEmojiCodePointWithSkinTone';
import * as React from 'react';

// The Component props
export interface EmojiIconProps {
    name: string;
    onClick: (emojiKey: string) => void;
    isSelected?: boolean;
    cssClassName?: string;
}

const styles = require('./EmojiIcon.scss');
const classNames = require('classnames/bind').bind(styles);

const EmojiIcon = observer(function EmojiIcon(props: EmojiIconProps) {
    const { name, onClick, isSelected, cssClassName } = props;
    const iconClassNames = classNames(styles.icon, cssClassName, {
        isSelected: isSelected,
    });

    const onSelectEmoji = React.useCallback(() => onClick(name), [name]);

    const emoji = getEmoji(name);
    return emoji ? (
        <CommandButton
            className={iconClassNames}
            onClick={onSelectEmoji}
            text={getEmojiCodePointWithSkinTone(emoji)}
            data-is-focusable={true}
        />
    ) : null;
});

export default EmojiIcon;
